export default __webpack_public_path__ + "6f2068dac09fcdb510a1b6fc3c9c2a0b.svg";